<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle || 'Summary of Day'"
      [canGoBack]="true"
      [customBack]="jobBackPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (!propertiesWithEvents || propertiesWithEvents?.length === 0) {
      <tidy-alert>
        <tidy-row class="no-padding">
          <tidy-text
            [body]="'No events on this day'" />
        </tidy-row>
      </tidy-alert>
    }

    @for (property of propertiesWithEvents; track property) {
      <tidy-row>
        <tidy-text
          [header]="property?.name || property?.address" />
      </tidy-row>
      @for (block of property.ownerBlocks; track block.id) {
        <div class="owner-block-day-item">
          <app-owner-block-card
            size="md"
            [block]="block"
            [address]="property?.name || property?.address"
            (unblocked)="onBlockUnblocked(property, block)" />
        </div>
      }
      @for (item of property.items; track item) {
        @if (!item?.booking && !item?.parsedRequestTimes) {
          <tidy-alert>
            <tidy-card-button (action)="goToReservation(item)" class="no-below-stroke no-padding">
              <ion-row>
                <tidy-row class="vertical-align-center no-padding">
                  <tidy-image
                    [src]="item?.icon" style="width: 30px" />
                </tidy-row>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [header]="(item?.isCheckIn ? 'Check In' : 'Check Out') | titlecase" />
                  </tidy-row>
                  <tidy-row class="no-padding">
                    <tidy-text
                      [body]="'Check in:'" /><span>&nbsp;</span>
                      <tidy-text
                    [body]="(item?.period?.startDate | parseDateTime: 'ddd') + ' ' + (item?.period?.startDate | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="'at'" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="item?.checkInTime" />
                        </tidy-row>
                        <tidy-row class="no-padding">
                          <tidy-text
                            [body]="'Check out:'" /><span>&nbsp;</span>
                            <tidy-text
                    [body]="(item?.period?.endDate | parseDateTime: 'ddd') + ' ' + (item?.period?.endDate | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
                              <tidy-text
                                [body]="'at'" /><span>&nbsp;</span>
                                <tidy-text
                                  [body]="item?.checkOutTime" />
                              </tidy-row>
                            </ion-col>
                          </ion-row>
                        </tidy-card-button>
                      </tidy-alert>
                    }
                    @if (item?.booking || item?.parsedRequestTimes) {
                      <tidy-card>
                        <tidy-card-button (action)="goToJobPage(item)" class="no-below-stroke no-padding">
                          <ion-row>
                            <tidy-row class="vertical-align-center no-padding">
                              <tidy-image
                                [src]="item?.status?.icon || item?.icon"
                                style="width: 30px" />
                            </tidy-row>
                            <ion-col>
                              <tidy-row>
                                <tidy-text
                                  [header]="item?.service_name | titlecase" />
                              </tidy-row>
                              @if (!item?.parsedRequestTimes) {
                                <tidy-row class="no-padding">
                                  <tidy-text
                                    [body]="(item?.startDate | parseDateTime: 'ddd') + ' ' + (item?.startDate | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
                                    <tidy-text
                                      [body]="'at'" /><span>&nbsp;</span>
                                      <tidy-text
                                        [body]="item?.time" />
                                    </tidy-row>
                                  }
                                  @if (item?.parsedRequestTimes) {
                                    <tidy-row class="no-padding">
                                      <tidy-text
                                        [body]="item?.parsedRequestTimes" />
                                    </tidy-row>
                                  }
                                </ion-col>
                              </ion-row>
                            </tidy-card-button>
                          </tidy-card>
                        }
                      }
                    }

                  </tidy-wrapper>
                </ng-template>

                @if (!isRightSideContent) {
                  <app-scroll-wrapper [templateContent]="content" />
                }

                @if (isRightSideContent) {
                  <ion-content class="ion-content-right-column">
                    <ng-container *ngTemplateOutlet="content" />
                  </ion-content>
                }
